module.exports = __webpack_public_path__ + "img/njangi.5c38180c.png";